import classnames from 'classnames';
import * as React from 'react';

import { Icon } from '@ao-internal/components-react';

export const LoadingSpinner: React.FC<React.HTMLProps<HTMLDivElement>> = ({
	className,
}) => {
	return (
		<div
			data-testid="chat-window-loading"
			className={classnames(
				'ao-loader absolute inset-0 text-center bg-white',
				className
			)}
		>
			<div className="ao-loader-inner">
				<div className="ao-loader-content">
					<div
						className="ao-loader-logo-container"
						style={{ width: '60px', height: '60px' }}
					>
						<div className="ao-loader-bounce">
							<Icon
								icon="ao-logo"
								className="ao-loader-logo text-ongreen"
								style={{ fontSize: '60px' }}
							/>
						</div>
						<div className="ao-loader-shadow"></div>
					</div>
					<div className="ao-loader-progress text-body-sm pt-2 font-bold">
						Please wait, loading&hellip;
					</div>
				</div>
			</div>
		</div>
	);
};

export default LoadingSpinner;
